import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class IsGuestGuard implements CanActivate {
  constructor(private _auth: AuthService, private _router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const role = this._auth.role;
    const isGuestOrBetter = ['guest', 'user', 'admin'].includes(role || '');
    const redirect = state.url;
    if (!isGuestOrBetter) {
      this._router.navigate(['/login'], { queryParams: { redirect } });
    }

    return isGuestOrBetter;
  }
}
